import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    UpdateStatus: null
};

export const fetchPricingList = createAsyncThunk(
    "fetchPricingList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/package/fetch-all-package?page=${body.page}&search=${body.search}&status=${body.status}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

// toggle PACKAGE switch 
export const UpdatePackageStatus = createAsyncThunk(
    "UpdatePackageStatus",
    async (data) => {
        try {
            const response = await instance.post(`/remark/package/update-package-status?id=${data?.id}&pck_emp_status=${data?.pck_emp_status}`)
            return response.data
        } catch (error) {
            throw error;
        }
    }
)


export const PricingSlice = createSlice({
    name: "PricingSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchPricingList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchPricingList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchPricingList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(UpdatePackageStatus.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(UpdatePackageStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.UpdateStatus = action?.payload;
        });
        builder.addCase(UpdatePackageStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default PricingSlice.reducer;
